import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { env } from '../config/env.config';

const createDemoSession = async () => {
  const response = await fetch(
    `${env.VITE_PLATFORM_API_URL}/Operator/create-demo-session`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        language: 'EN',
        gameCode: 'Towers',
      }),
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.text();
};

export const useCreateDemoSession = (
  options?: Omit<
    UseMutationOptions<Awaited<ReturnType<typeof createDemoSession>>>,
    'mutationFn'
  >
) => {
  return useMutation({
    mutationFn: createDemoSession,
    ...options,
  });
};
